/** Column id of the experiments table's pinned row-actions column, shared with every other table. */
export { ACTIONS_COLUMN_ID } from "@phoenix/components/table/constants";

/** Prefix of the column id derived from an annotation name. */
export const ANNOTATION_COLUMN_PREFIX = "annotation-";
